import uuidv4 from 'uuid/v4';

export function addSubjectToCourse(courses, subject){

    return (
        courses.map(course => {
            if(course.id === subject.courseId){
                return {
                    name: course.name,
                    slug: course.slug,
                    id: course.id,
                    description: course.description,
                    CourseSubject: [...course.CourseSubject, subject]
                }
            }else{
                return {
                    ...course
                }
            }
        })
    )
}


// WEBPACK FOOTER //
// ./src/utils/CourseSubjectsTransformations.js